import { ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { buildAdminEmissionFactorPath } from "../../shared/routing/paths/admin";
import { FIRST_CURATED_LIST } from "./shared/curated-list-options";

/**
 * `/emission-factors` has no page of its own, and app-shell's sidebar can still point at a list
 * that was removed. Both land on the first list, whose menu switches to the others. `search` is
 * carried over because the sidebar stamps `target_account` onto service links.
 */
export const CuratedListRedirect = (): ReactElement => {
  const location = useLocation();

  return (
    <Navigate to={{ pathname: buildAdminEmissionFactorPath(FIRST_CURATED_LIST), search: location.search }} replace />
  );
};
